(function (window) {
  'use strict';

  var RandolphSwiperA11y = {
    parseSlideNames: function (el) {
      try {
        return JSON.parse(el.getAttribute('data-slide-names') || '[]');
      } catch (e) {
        return [];
      }
    },

    escapeForAttr: function (str) {
      return String(str).replace(/"/g, '&quot;');
    },

    paginationConfig: function (slideNames, paginationEl, options) {
      var self = this;
      options = options || {};
      var useButton = options.useButton === true;
      var usePosition = options.usePositionLabels === true;
      var total = slideNames.length;
      return {
        el: paginationEl,
        clickable: true,
        renderBullet: function (index, className) {
          var label;
          if (usePosition && total) {
            label = (index + 1) + ' of ' + total + ' slide';
          } else {
            var name = slideNames[index] || ('Item ' + (index + 1));
            label = 'Show ' + self.escapeForAttr(name);
          }
          if (useButton) {
            return '<button type="button" class="' + className + '" aria-label="' + label + '"></button>';
          }
          return '<span class="' + className + '" role="button" tabindex="0" aria-label="' + label + '"></span>';
        }
      };
    },

    syncPaginationLabels: function (sliderEl, slideNames, options) {
      var usePosition = options && options.usePositionLabels === true;
      var total = slideNames.length;
      Array.prototype.forEach.call(sliderEl.querySelectorAll('.swiper-pagination-bullet'), function (bullet, index) {
        var isActive = bullet.classList.contains('swiper-pagination-bullet-active');
        var label = '';
        if (usePosition && total) {
          label = (index + 1) + ' of ' + total + ' slide';
        } else if (slideNames[index]) {
          label = 'Show ' + slideNames[index];
        }
        if (label) {
          bullet.setAttribute('aria-label', label);
        }
        if (isActive) {
          bullet.setAttribute('aria-current', 'true');
        } else {
          bullet.removeAttribute('aria-current');
        }
      });
    },

    syncSliderFocus: function (swiper, options) {
      if (!swiper || !swiper.slides) return;
      var sliderEl = swiper.el;
      var slideNames = sliderEl ? this.parseSlideNames(sliderEl) : [];
      var usePosition = options && options.usePositionLabels === true;
      var wrapper = sliderEl && sliderEl.querySelector('.swiper-wrapper');
      var total = slideNames.length;
      if (!total) {
        total = Array.prototype.filter.call(swiper.slides, function (slide) {
          return !slide.classList.contains('swiper-slide-duplicate');
        }).length;
      }
      if (wrapper) {
        wrapper.setAttribute('aria-live', 'off');
        wrapper.setAttribute('aria-atomic', 'false');
      }

      Array.prototype.forEach.call(swiper.slides, function (slide) {
        var isDuplicate = slide.classList.contains('swiper-slide-duplicate');
        var isVisible = slide.classList.contains('swiper-slide-visible') || slide.classList.contains('swiper-slide-active');
        var focusable = !isDuplicate && isVisible;
        var nameIndex = slide.getAttribute('data-swiper-slide-index');
        var positionIndex = nameIndex !== null ? parseInt(nameIndex, 10) : NaN;
        var slideName = '';

        if (isNaN(positionIndex)) {
          var realSlides = Array.prototype.filter.call(swiper.slides, function (s) {
            return !s.classList.contains('swiper-slide-duplicate');
          });
          positionIndex = realSlides.indexOf(slide);
        }

        if (!isNaN(positionIndex) && positionIndex >= 0 && slideNames[positionIndex]) {
          slideName = slideNames[positionIndex];
        }

        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        if (usePosition && total && !isNaN(positionIndex) && positionIndex >= 0) {
          slide.setAttribute('aria-label', (positionIndex + 1) + ' of ' + total);
        } else if (slideName && !slide.getAttribute('aria-label')) {
          slide.setAttribute('aria-label', slideName);
        }
        slide.setAttribute('aria-hidden', focusable ? 'false' : 'true');
        if (options && options.focusSlides === true) {
          slide.setAttribute('tabindex', focusable ? '0' : '-1');
        }
        Array.prototype.forEach.call(slide.querySelectorAll('a, button, input, select, textarea, [tabindex]'), function (el) {
          if (el === slide) return;
          if (el.classList && el.classList.contains('swiper-pagination-bullet')) return;
          if (el.closest && el.closest('.slidecontent')) {
            el.setAttribute('tabindex', '-1');
            return;
          }
          if (focusable) {
            if (el.getAttribute('tabindex') === '-1') {
              el.removeAttribute('tabindex');
            }
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });
      });
    },

    buildHandlers: function (sliderEl, slideNames, options) {
      var self = this;
      options = options || {};
      var syncFocus = options.syncFocus !== false;

      return {
        init: function (swiper) {
          if (syncFocus) self.syncSliderFocus(swiper, options);
          self.syncPaginationLabels(sliderEl, slideNames, options);
        },
        slideChange: syncFocus ? function (swiper) {
          self.syncSliderFocus(swiper, options);
          self.syncPaginationLabels(sliderEl, slideNames, options);
        } : function () {
          self.syncPaginationLabels(sliderEl, slideNames, options);
        },
        resize: syncFocus ? function (swiper) {
          self.syncSliderFocus(swiper, options);
        } : undefined,
        paginationUpdate: function () {
          self.syncPaginationLabels(sliderEl, slideNames, options);
        }
      };
    },

    disabledConfig: function () {
      return { enabled: false };
    }
  };

  window.RandolphSwiperA11y = RandolphSwiperA11y;
})(window);
